<template>
    <div class="relative bg-base-100 rounded-md overlow-auto">
        <document-preview v-if="docCount === 1 && documentMetaUuids[0]" :document-meta-uuid="documentMetaUuids[0]" />
        <div v-else-if="docCount > 1 && selectedDocMetaUuid">
            <document-preview :document-meta-uuid="selectedDocMetaUuid" />
            <div class="flex justify-center gap-1 sticky bottom-0 bg-base-100 rounded-md p-2">
                <UButton
                    icon="i-ph-caret-left"
                    color="neutral"
                    variant="outline"
                    @click="setPrev"
                />
                <UButton
                    v-for="(uuid, index) in documentMetaUuids"
                    :key="uuid"
                    :variant="selectedDocMetaUuid == uuid ? 'solid' : 'outline'"
                    :color="selectedDocMetaUuid == uuid ? 'primary' : 'neutral'"
                    @click="selectedDocMetaUuid = uuid"
                >
                    {{ index + 1 }}
                </UButton>
                <UButton
                    icon="i-ph-caret-right"
                    variant="outline"
                    color="neutral"
                    @click="setNext"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, onMounted, PropType, ref} from 'vue'
import hotkeys from 'hotkeys-js'
import DocumentPreview from '@/document/DocumentPreview.vue'

const props = defineProps({
    documentMetaUuids: {
        type: Array as PropType<string[]>,
        required: true
    }
})

const docCount = computed(() => props.documentMetaUuids.length)
const selectedDocMetaUuid = ref('')

const selectedIndex = computed(() => props.documentMetaUuids.indexOf(selectedDocMetaUuid.value))

onMounted(() => {
    selectedDocMetaUuid.value = props.documentMetaUuids[0] || ''
})

const setPrev = () => {
    const index = selectedIndex.value - 1
    if (index < 0) {
        selectedDocMetaUuid.value = props.documentMetaUuids[docCount.value - 1]
    } else {
        selectedDocMetaUuid.value = props.documentMetaUuids[index]
    }
}

const setNext = () => {
    const index = selectedIndex.value + 1
    if (index >= docCount.value) {
        selectedDocMetaUuid.value = props.documentMetaUuids[0]
    } else {
        selectedDocMetaUuid.value = props.documentMetaUuids[index]
    }
}

hotkeys('left', setPrev)
hotkeys('right', setNext)

</script>